import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages the market-selector (language & location) drawer.
 *
 * Triggered from the menu drawer's corner CTA button. Closes the mega-menu
 * (`header-drawer`) first, then slides itself in from the right as a standard
 * right-side dialog drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends {DialogComponent}
 */
class MarketSelectorDrawer extends DialogComponent {
  /**
   * Close the mega-menu drawer (if open) then open this drawer.
   */
  show() {
    const headerDrawer = /** @type {HTMLElement & { close?: () => void } | null} */ (
      document.querySelector('header-drawer')
    );

    if (headerDrawer && typeof headerDrawer.close === 'function') {
      headerDrawer.close();
    }

    this.showDialog();
  }

  /**
   * Close this drawer — delegates to DialogComponent.
   */
  close() {
    this.closeDialog();
  }
}

if (!customElements.get('market-selector-drawer')) {
  customElements.define('market-selector-drawer', MarketSelectorDrawer);
}
